export default "__VITE_ASSET__ah7OZIRV__"